<h1 mat-dialog-title class="mb-1">Verify</h1>
<div mat-dialog-content>
  <h4 *ngIf="(model$ | async)?.overallStatus == 'PENDING'" class="alert alert-info mt-4" [innerHTML]="pendingText"></h4>
  <div id="greenid-div">
  </div>
  <div *ngIf="data.errorList; let list">
    <h4 class="mt-4">In order to have your data verified, please update your details</h4>
    <ul>
      <li *ngFor="let i of list">{{i}}</li>
    </ul>
  </div>
</div>
<div mat-dialog-actions class="mt-4 float-right">
  <button class="btn btn-link" (click)="onCancelClick()">Close</button>
  <button class="btn btn-primary" *ngIf="data.errorList.length >0 && data.updateDataLink" (click)="onUpdateDataClick()"
    cdkFocusInitial>Update details</button>
</div>
